import { render, staticRenderFns } from "./CulturalHigherVocational.vue?vue&type=template&id=afd150ee&scoped=true"
import script from "./CulturalHigherVocational.vue?vue&type=script&lang=js"
export * from "./CulturalHigherVocational.vue?vue&type=script&lang=js"
import style0 from "./CulturalHigherVocational.vue?vue&type=style&index=0&id=afd150ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd150ee",
  null
  
)

export default component.exports